import React from 'react';
import { localStorageHandler } from 'core/services';

function FooterTemplate() {
	const version = localStorageHandler.get('appVersion');
	return (
		<div className="footer__footer">
			<p>Copyright 2023 Milliard&trade; v{version}</p>
			<div className="push">
				<a>Terms of Use</a> | <a>Privacy Policy</a>
			</div>
		</div>
	);
}

export default FooterTemplate;



// WEBPACK FOOTER //
// ./src/themes/default/components/FooterTemplate.jsx